import { Checkbox } from '@mantine/core';

import { useUpdateWithdrawalMethod } from '../hooks/use-update-withdrawal-method';

import type { TWithdrawalMethod, TWithdrawalMethodUpdateParams } from '../store/types';

type Props = {
  method: TWithdrawalMethod;
};

export const WithdrawalMethodActiveUpdate = (props: Props) => {
  const { method } = props;
  const {
    handleSubmit,
  } = useUpdateWithdrawalMethod({ withdrawalMethod: method });

  const onMethodActiveChange = () => {
    const changedMethod: TWithdrawalMethodUpdateParams = {
      methodId: method.id,
      name: method.name,
      currency: method.currency,
      minAmount: method.minAmount,
      maxAmount: method.maxAmount,
      withdrawalPercent: method.withdrawalPercent,
      withdrawalFee: method.withdrawalFee,
      active: !method.active,
    };
    handleSubmit(changedMethod);
  };

  return (
    <Checkbox
      style={{ display: 'flex', justifyContent: 'center' }}
      checked={method.active}
      onChange={onMethodActiveChange}
    />
  );
};
